<!-- eslint-disable max-lines -->
<template>
    <div class="home-search-list">
        <div class="search-left">
            <div v-for="(item, index) in searchListConfig" :key="index">
                <lots-select v-if="item.prop === 'ebcdCode'" class="w155 search-select mr16  " optionsKey=""
                    :options="ebcdData" collapse-tags filterable :placeholder="item.placeholder"
                    :multiple="item.multiple" v-model="searchModel.ebcdCode"
                    @visible-change="($event) => blurChange($event)"
                    @remove-tag="data => { removeTagHandle(data, 'ebcdCode') }"
                    @change="data => { searchChangeList(data, 'ebcdCode') }" clearable />
                <el-cascader v-if="item.prop === 'industryCategory'" ref="cascaderRef" :key="industryData.length"
                    :class="['search-cascader mr16', item.className]" v-model="searchModel.industryCategory"
                    :options="industryData" :props="industryCategoryProps" :placeholder="item.placeholder" collapse-tags
                    clearable @visible-change="($event) => blurChange($event)"
                    @remove-tag="data => { removeTagHandle(data, 'industryCategory') }"
                    @change="(data) => { getCascaderValue(data, 'industryCategory'); }"></el-cascader>

                <lots-select v-if="item.prop === 'areaCode'" class="w155 search-select mr16 " optionsKey=""
                    :options="areaData" :placeholder="item.placeholder" :multiple="item.multiple" collapse-tags
                    filterable v-model="searchModel.areaCode" @visible-change="($event) => blurChange($event)"
                    @remove-tag="data => { removeTagHandle(data, 'areaCode') }"
                    @change="data => { searchChangeList(data, 'areaCode') }" clearable />
                <lots-select v-if="item.prop === 'subBranchCode'" class="w155 search-select mr16 " optionsKey=""
                    :key="selectKey" :options="companyData" :placeholder="item.placeholder" :multiple="item.multiple"
                    collapse-tags filterable v-model="searchModel.subBranchCode"
                    @remove-tag="data => { removeTagHandle(data, 'subBranchCode') }"
                    @visible-change="($event) => blurChange($event)"
                    @change="data => { searchChangeList(data, 'subBranchCode') }" clearable />
                <lots-select v-if="item.prop === 'businessSceneBigCategory'" class="w155 search-select mr16 "
                    optionsKey="" :key="selectKey" :options="businessData" :placeholder="item.placeholder"
                    :multiple="item.multiple" collapse-tags filterable v-model="searchModel.businessSceneBigCategory"
                    @visible-change="($event) => blurChange($event)"
                    @remove-tag="data => { removeTagHandle(data, 'businessSceneBigCategory') }"
                    @change="data => { searchChangeList(data, 'businessSceneBigCategory') }" clearable />
                <lots-select v-if="item.prop === 'bigEbcdName'" class="w155 search-select mr16 " optionsKey=""
                    :key="selectKey" :options="bigEbcdNameData" :placeholder="item.placeholder"
                    :multiple="item.multiple" collapse-tags filterable v-model="searchModel.bigEbcdName"
                    @visible-change="($event) => blurChange($event)"
                    @remove-tag="data => { removeTagHandle(data, 'bigEbcdName') }"
                    @change="data => { searchChangeList(data, 'bigEbcdName') }" clearable />

                <el-radio-group class="search-radio mr16"
                    v-if="item.prop === 'customerlevelName' && item.fixed === 'left'"
                    v-model="searchModel.customerlevelName" @input="(data) => inputStatus(data, 'customerlevelName')"
                    size="mini">
                    <el-radio-button label="所有">所有</el-radio-button>
                    <el-radio-button label="TOP">TOP</el-radio-button>
                    <el-radio-button label="行业CKA">行业CKA</el-radio-button>
                    <el-radio-button label="属地CKA">属地CKA</el-radio-button>
                    <el-radio-button label="无收入CKA">无收入CKA</el-radio-button>
                    <el-radio-button label="普通">普通</el-radio-button>
                </el-radio-group>

                <div class="search-right search-radio mr16" v-if="item.prop === 'timeStatus' && item.fixed === 'left'">
                    <el-radio-group v-model="searchModel.timeStatus"
                        @input="(data) => inputTimeStatus(data, 'timeStatus')" size="mini">
                        <el-radio-button label="year">年</el-radio-button>
                        <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>
                    <span class="time-box">
                        <el-date-picker v-if="searchModel.timeStatus === 'year'"
                            class="search-time search-select bigData-btn-home-page-search-time-year"
                            v-model="searchModel.yearTime" :key="searchModel.timeStatus" format="yyyy"
                            value-format="yyyy" :clearable="false" type="year" :pickerOptions="{ disabledDate }"
                            @change="data => searchTimeChangeList(data,'year')" placeholder="选择年">
                        </el-date-picker>
                        <el-date-picker v-else :key="searchModel.timeStatus"
                            class="search-time search-select search-month-time"
                            v-model="searchModel.monthTime" format="yyyy-MM" value-format="yyyy-MM" :clearable="false"
                            type="month" :pickerOptions="{ disabledDate }" @change="data => searchTimeChangeList(data,'month')"
                            placeholder="选择月">
                        </el-date-picker>
                        <i class="custom-arrow-icon el-icon-arrow-down"></i>
                    </span>

                </div>
                <el-radio-group class="search-radio mr16"
                    v-if="item.prop === 'costType' && item.fixed === 'left' && searchModel.timeStatus==='month'"
                    v-model="searchModel.costType" @input="(data) => inputStatus(data, 'costType')"
                    size="mini">
                    <el-radio-button label="1">当月</el-radio-button>
                    <el-radio-button label="2">累计</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="search-right">
            <div class="search-radio "
                v-if="searchListConfig.some(it => (['timeStatus', 'customerlevelName'].includes(it.prop)) && it.fixed === 'right')">
                <el-radio-group class="search-radio mr16"
                    v-if="searchListConfig.some(it => (['customerlevelName'].includes(it.prop)) && it.fixed === 'right')"
                    v-model="searchModel.customerlevelName" @input="(data) => inputStatus(data, 'customerlevelName')"
                    size="mini">
                    <el-radio-button label="所有">所有</el-radio-button>
                    <el-radio-button label="TOP">TOP</el-radio-button>
                    <el-radio-button label="行业CKA">行业CKA</el-radio-button>
                    <el-radio-button label="属地CKA">属地CKA</el-radio-button>
                    <el-radio-button label="无收入CKA">无收入CKA</el-radio-button>
                    <el-radio-button label="普通">普通</el-radio-button>
                </el-radio-group>
                <el-radio-group v-model="searchModel.timeStatus" @input="(data) => inputTimeStatus(data, 'timeStatus')"
                    size="mini">
                    <el-radio-button label="year">年</el-radio-button>
                    <el-radio-button label="month">月</el-radio-button>
                </el-radio-group>
                <span class="time-box">
                    <el-date-picker v-if="searchModel.timeStatus === 'year'" class="search-time search-select"
                        v-model="searchModel.yearTime" :key="searchModel.timeStatus" format="yyyy" value-format="yyyy"
                        :clearable="false" type="year" :pickerOptions="{ disabledDate }"
                        @change="data => searchTimeChangeList(data,'year')" placeholder="选择年">
                    </el-date-picker>
                    <el-date-picker v-else :key="searchModel.timeStatus"
                        :class="['search-time search-select search-month-time']" v-model="searchModel.monthTime"
                        format="yyyy-MM" value-format="yyyy-MM" :clearable="false" type="month"
                        :pickerOptions="{ disabledDate }" @change="data => searchTimeChangeList(data,'month')"
                        placeholder="选择月">
                    </el-date-picker>
                    <i class="custom-arrow-icon el-icon-arrow-down"></i>
                </span>
                   <el-radio-group class="search-radio mr16"
                    v-if="searchListConfig.some(it => (['costType'].includes(it.prop)) && it.fixed === 'right') && searchModel.timeStatus==='month'"
                    v-model="searchModel.costType" @input="(data) => inputStatus(data, 'costType')"
                    size="mini">
                    <el-radio-button label="1">当月</el-radio-button>
                    <el-radio-button label="2">累计</el-radio-button>
                </el-radio-group>
            </div>
        </div>
    </div>

</template>

<script>
import { onMounted, ref, watch } from '@vue/composition-api';
import { lotInputParams } from './config';
import { parseTime } from '@/utils/index.js';
import lotsSelect from '@/components/lots/lotsSelect/Index';
import {
    getIndustryTree
} from '@mdm/api/contractManage/contractRegistration.js';
import { queryAllCompanyList, getCompanyByAreaList, getPersonalCompanyByArea, getHomepageIncomeFilterOptions, queryBigProfessionalCompany } from '@/api/homePageApi.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import utils from '@/utils/common';
import utilsComp from '@/components/utils/common.js';
import bigDataLog from '@/utils/bigDataLog.js';
// import lotsMdInput from '@/components/lots/lotsMdInput';
import _ from 'lodash';
// const bigDataLogList = {
//     time: 'bigData-btn-home-page-search-time-name',
//     level: 'bigData-btn-home-page-search-customerlevel-name',
//     subBranchCode: 'bigData-btn-home-page-search-subBranchCode',
//     areaCode: 'bigData-btn-home-page-search-areaCode',
//     ebcdCode: 'bigData-btn-home-page-search-ebcdCode'
// };
export default {
    components: { lotsSelect },
    props: {
        searchListConfig: {
            type: Array,
            return: () => {
                return [];
            }
        },
        currentRole: {
            type: Object,
            return: () => {
                return {};
            }
        },
        searchOptionsList: {
            type: Object,
            return: () => {
                return {};
            }
        },
        searchInitData: {
            type: Object,
            return: () => {
                return {};
            }
        }

    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const industryCategoryProps = ref({
            multiple: true,
            value: 'code',
            label: 'name'
        });
        const initSearchData = {
            industryCategory: [],
            companyCode: [],
            ebcdCode: [],
            subBranchCode: [],
            areaCode: [],
            time: new Date().getFullYear() + '',
            // yearTime: new Date().getFullYear(),
            yearTime: utilsComp.formatDateTime(new Date(), 'YYYY'),
            monthTime: utilsComp.formatDateTime(new Date(), 'YYYY-MM'),
            customerlevelName: '所有',
            costType: '1',
            timeStatus: 'month'
        };
        const initSearchDataParamFunc = (data) => {
            props.searchListConfig.forEach(it => {
                if (it.type === 'select') {
                    data[it.prop] = it.defaultValue || (it.multiple ? [] : '');
                } else if (it.type === 'cascader') {
                    data[it.prop] = it.defaultValue || [];
                } else if (it.type === 'radio') {
                    data[it.prop] = it.defaultValue || '所有';
                } else if (it.type === 'time') {
                    data[it.prop] = 'month';
                    data.yearTime = utilsComp.formatDateTime(new Date(), 'YYYY');
                    data.monthTime = utilsComp.formatDateTime(new Date(), 'YYYY-MM');
                }
            });
            return data;
        };
        const searchModel = ref(_.cloneDeep(initSearchData));
        const initSearchDataFunc = (val) => {
            setSearchDataOptions();
            searchModel.value = _.cloneDeep(initSearchDataParamFunc(initSearchData));
            setTimeout(() => {
                if (val.dataType) {
                    searchModel.value.dataType = val.dataType;
                    searchModel.value.dataTime = val.dataTime;
                }
                if (searchModel.value.dataType === 'Y') {
                    searchModel.value.timeStatus = 'year';
                    searchModel.value.yearTime = searchModel.value.dataTime;
                } else if (searchModel.value.dataType === 'M') {
                    searchModel.value.timeStatus = 'month';
                    searchModel.value.monthTime = searchModel.value.dataTime;
                }
                setupContext.emit('search-handle', formatSearchData(searchModel.value));
            });
        };
        const setSearchDataOptions = async () => {
            if (props.currentRole.dataType !== 'personal') {
                industryData.value = formatSetNullData(props.searchOptionsList.authIndustryCategoryList);
                areaData.value = setSelectOption(props.searchOptionsList.authRegionList);
                companyData.value = setSelectOption(props.searchOptionsList.authCompanyList);
                ebcdData.value = setSelectOption(props.searchOptionsList.authBigProfessionalCompanyList);
                await getBusinessList();
                bigEbcdNameData.value = setSelectOption(props.searchListConfig.find(it => it.prop === 'bigEbcdName')?.options);
                searchModel.value = _.merge(_.cloneDeep(initSearchData), props.searchInitData);
            } else {
                await getIndustryTreeList();
                await getDictData();
                await getCompanyTreeList();
                await getBigProfessionalCompany();
                // await getPersonalCompanyByAreaInfo();
                await getBusinessList();
                bigEbcdNameData.value = setSelectOption(props.searchListConfig.find(it => it.prop === 'bigEbcdName')?.options);
                searchModel.value = _.merge(_.cloneDeep(initSearchData), props.searchInitData);
            }
        };
        const searchTimeChangeList = (data, prop) => {
            if (searchModel.value.timeStatus === 'year') {
                currentYear.value = data;
                searchModel.value.yearTime = data;
                searchModel.value.dataTime = data;
                searchModel.value.dataType = 'Y';
            } else {
                currentMonth.value = data;
                searchModel.value.monthTime = data;
                searchModel.value.dataTime = data;
                searchModel.value.dataType = 'M';
            }
            setupContext.emit('search-handle', formatSearchData(searchModel.value));
            const currentLog = props.searchListConfig.find(it => it.prop === 'timeStatus');
            if (!currentLog.className) return;
            bigDataLog.sendDetailMessageByKey(currentLog.className + '-' + prop);
        };
        // const setStrFormat = (val) => {
        //     return val?.map(item => `'${item}'`).join(',') || '';
        // };
        // 获取大专司选项-个人
        const getBigProfessionalCompany = () => {
            return queryBigProfessionalCompany({}).then(res => {
                if (res && +res.code === 0) {
                    ebcdData.value = setSelectOption(res.data) || [];
                }
            });
        };

        const selectKey = ref(1);
        const getPersonalCompanyByAreaInfo = () => {
            const params = {
                'authCode': String(searchModel.value.areaCode)
            };
            if (!String(searchModel.value.areaCode)) {
                return getCompanyTreeList();
            }
            return getPersonalCompanyByArea(params).then(res => {
                if (res && +res.code === 0) {
                    companyData.value = setSelectOption(res.data?.map(it => {
                        return {
                            code: it.code,
                            name: it.name
                        };
                    }) || []);
                    selectKey.value++;
                } else {
                    companyData.value = [];
                    selectKey.value++;
                }
            }).catch((e) => {
                companyData.value = [];
                selectKey.value++;
            });
        };
        const getCompanyByAreaInfo = () => {
            const params = {
                'authCode': String(searchModel.value.areaCode)
            };
            if (!params.authCode) {
                companyData.value = setSelectOption(props.searchOptionsList.authCompanyList);
                return;
            }
            getCompanyByAreaList(params).then(res => {
                if (res && +res.code === 0) {
                    companyData.value = setSelectOption(res.data?.map(it => {
                        return {
                            code: it.code,
                            name: it.name
                        };
                    }) || []);
                    selectKey.value++;
                } else {
                    companyData.value = [];
                    selectKey.value++;
                }
            }).catch((e) => {
                companyData.value = [];
                selectKey.value++;
            });
        };
        const searchChangeList = (data, prop) => {
            // if (!row.ownerMip) return;
            // window.location.href = `MeiCloud://Message/?uid=${row.ownerMip}`;
            if (prop === 'areaCode') {
                searchModel.value.subBranchCode = [];
                if (props.currentRole.dataType === 'personal') {
                    getPersonalCompanyByAreaInfo();
                } else {
                    getCompanyByAreaInfo();
                }
            }
            if (data.length === 0) {
                setupContext.emit('search-handle', formatSearchData(searchModel.value));
            }
            const currentLog = props.searchListConfig.find(it => it.prop === prop);
            if (!currentLog.className) return;
            bigDataLog.sendDetailMessageByKey(currentLog.className);
        };
        const getCascaderValue = (data, prop) => {
            if (data.length === 0) {
                setupContext.emit('search-handle', formatSearchData(searchModel.value));
            }
        };
        const currentTime = ref('');
        const resetLoading = ref(false);
        const resetCurrent = () => {
            currentTime.value = parseTime(new Date(), 'yyyy-MM-dd hh:mm');
            resetLoading.value = true;
            setupContext.emit('reset-current', searchModel.value);
        };
        const currentRole = ref({});
        const OLD_CUSTOMER_LEVEL_YEAR = 2026;
        watch(() => props.currentRole, (val) => {
            currentRole.value = val;
        }, { deep: true, immediate: true });
        watch(() => searchModel.value.timeStatus, (val) => {
            searchModel.value.costType = '1';
        }, { deep: true, immediate: true });

        //  切换角色
        const handleRole = (item) => {
            if (item.roleCode === props.currentRole.roleCode) return;
            currentRole.value = item;
            setupContext.emit('handle-role', searchModel.value);
        };
        const inputStatus = (data, prop) => {
            setupContext.emit('search-handle', formatSearchData(searchModel.value));
            const currentLog = props.searchListConfig.find(it => it.prop === prop);
            if (!currentLog.className) return;
            bigDataLog.sendDetailMessageByKey(currentLog.className);
        };
        const timeStatus = ref('month');
        const yearList = ref({});
        const currentYear = ref(new Date().getFullYear());
        // const currentMonth = ref('');
        const currentMonth = ref(utils.formatMonth(new Date()));
        const inputTimeStatus = (data, prop) => {
            setTimeout(() => {
                if (data === 'year') {
                    searchModel.value.timeStatus = 'year';
                    // searchModel.value.yearTime = searchModel.value.dataTime;
                } else if (data === 'month') {
                    searchModel.value.timeStatus = 'month';
                    // searchModel.value.monthTime = searchModel.value.dataTime;
                }
                setupContext.emit('search-handle', formatSearchData(searchModel.value));
                const currentLog = props.searchListConfig.find(it => it.prop === prop);
                if (!currentLog.className) return;
                bigDataLog.sendDetailMessageByKey(currentLog.className);
            });
        };
        const industryData = ref([]);
        const getIndustryTreeList = () => {
            return getIndustryTree({
                industryStatus: 1 // 0-停用、1-启用
            }).then(res => {
                if (res && +res.code === 0) {
                    const _res = res.data
                        .filter(it => it.industryName !== '非行业') // 过滤掉industryName=非行业的项
                        .map(it => ({
                            code: it.industryCode,
                            name: it.industryName,
                            children: []
                        }));
                    industryData.value = formatSetNullData(_res);
                }
            });
        };
        const disabledDate = (date) => {
            if (props.currentRole.dataType === 'personal') {
                // 计算当前时间
                const now = new Date();
                // 计算3年前的时间（从当前年月的前推2年）
                const threeYearsAgo = new Date();
                threeYearsAgo.setFullYear(now.getFullYear() - 2);

                // 设置threeYearsAgo为3年前第一个月的第一天（00:00:00）
                // 注意：月份从0开始，0代表1月
                const threeYearsAgoStart = new Date(threeYearsAgo.getFullYear(), threeYearsAgo.getMonth(), 1);

                // 禁用3年前第一天之前的所有时间
                // 同时也可以选择禁用今天之后的时间（根据你的需求，这里已注释）
                // return time.getTime() < threeYearsAgoStart.getTime() || time.getTime() > now.getTime();
                return date.getTime() < threeYearsAgoStart.getTime() || date.getTime() > now.getTime();
            }
            // }
            // const now = new Date();
            // const nowMonth = now.getMonth();
            // const nowYear = now.getFullYear();
            // const monthStartData = new Date(nowYear, nowMonth, 1); // 当月第一天
            // // const monthEndData = new Date(nowYear, nowMonth + 1, 0); // 当月最后一天
            // // return Boolean(date.getTime() > monthEndData.getTime() || date.getTime() < monthStartData.getTime());
            // return Boolean(date.getTime() < monthStartData.getTime());
        };
        const getCompanyTreeList = () => {
            return queryAllCompanyList({
                companyNameCn: '分公司',
                pageNo: 1,
                pageSize: 1000
            }).then(res => {
                if (res && +res.code === 0) {
                    const _res = res.data.list.map(it => {
                        return {
                            code: it.companyCode,
                            name: it.companyNameCn
                        };
                    });
                    companyData.value = setSelectOption(_res);
                }
            });
        };
        const businessData = ref({});
        const getBusinessList = () => {
            if (!props.searchListConfig?.some(it => it.prop === 'businessSceneBigCategory')) return;
            return getHomepageIncomeFilterOptions({
                roleType: props.currentRole.dataType
            }).then(res => {
                if (res && +res.code === 0) {
                    const _res = res.data.map(it => {
                        return {
                            code: it.pCode,
                            name: it.pName
                        };
                    });
                    businessData.value = setSelectOption(_res);
                }
            });
        };
        /**
     * @param {array} data: 源数据
     * @return 设置children:[] 为null
     * */
        const formatSetNullData = (data) => {
            if (!data) return [];
            data.forEach((item, index) => {
                if (item.children?.length >= 1) {
                    formatSetNullData(item.children);
                } else {
                    data[index].children = null;
                }
            });
            return data;
        };
        const getYearList = () => {
            const currentYear = new Date().getFullYear();
            // 获取前三年年份
            const years = {};
            for (let i = 0; i < 3; i++) {
                const year = currentYear - i;
                years[year] = year.toString();
            }
            return years;
        };
        const formatSearchData = (val) => {
            const _searchModel = _.cloneDeep(val);
            const currentYear = _searchModel.timeStatus === 'year' ? _searchModel.yearTime : _searchModel.monthTime?.split('-')[0];
            const isYearLessThan2026 = currentYear && parseInt(currentYear) < OLD_CUSTOMER_LEVEL_YEAR;
            if (isYearLessThan2026 && _searchModel.customerlevelName === '行业CKA' && props.currentRole.dataType !== 'personal') {
                _searchModel.customerlevelName = 'CKA';
            }
            return _searchModel;
        };
        const blurChange = (event) => {
            if (!event) {
                setupContext.emit('search-handle', formatSearchData(searchModel.value));
            }
        };
        const removeTagHandle = (data, prop) => {
            setupContext.root.$nextTick(() => {
                if (Array.isArray(searchModel.value[prop]) && searchModel.value[prop].length === 0) return;
                if (prop === 'areaCode') {
                    searchModel.value.subBranchCode = [];
                    if (props.currentRole.dataType === 'personal') {
                        getPersonalCompanyByAreaInfo();
                    } else {
                        getCompanyByAreaInfo();
                    }
                }
                setupContext.emit('search-handle', formatSearchData(searchModel.value));
            });
        };
        const dictData = ref({});
        const getDictData = async () => {
            const res = await getDictDataApi({ dictCodes: 'APP_COMPANY_AREA,SMALL_PROFESSIONAL_COMPANY_TEST' });
            dictData.value = res.data;
            // 个人类型-城配直营下拉数据-去除
            if (props.currentRole.dataType === 'personal') {
                Reflect.deleteProperty(res.data.APP_COMPANY_AREA, 'A');
            }
            areaData.value = res.data.APP_COMPANY_AREA;
            // ebcdData.value = res.data.SMALL_PROFESSIONAL_COMPANY_TEST;
        };
        onMounted(() => {
            yearList.value = getYearList();
        });
        const setSelectOption = data => {
            if (!data) return {};
            const obj = {};
            data.forEach(it => {
                obj[it.code] = it.name;
            });
            return obj;
        };
        const areaData = ref({});
        const companyData = ref({});
        const ebcdData = ref({});
        const bigEbcdNameData = ref({});
        // watch(() => [props.searchOptionsList, props.currentRole, props.searchTableInitData], async (val) => {
        watch(() => props.searchInitData, async (val) => {
            // if (!Object.keys(val).length) return;
            await setSearchDataOptions();
            if (searchModel.value.customerlevelName === 'CKA') {
                searchModel.value.customerlevelName = '行业CKA';
            }
            if (props.searchOptionsList.roleCode && props.currentRole.roleCode) {
                setupContext.emit('search-handle', formatSearchData(searchModel.value));
            }
        }, { deep: true, immediate: true });
        return {
            searchModel,
            lotInputParams,
            resetLoading,
            currentTime,
            timeStatus,
            industryCategoryProps,
            industryData,
            companyData,
            areaData,
            ebcdData,
            businessData,
            selectKey,
            bigEbcdNameData,
            searchTimeChangeList,
            blurChange,
            inputTimeStatus,
            searchChangeList,
            getCascaderValue,
            resetCurrent,
            handleRole,
            inputStatus,
            disabledDate,
            initSearchDataFunc,
            removeTagHandle
        };
    }
};
</script>
<style lang="less" scoped>
.home-search-list {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .search-left {
    display: flex;
    align-items: center;

    .w146 {
      // width: 146px!important;
      width: 136px !important;
    }

    .w155 {
      // width: 155px!important;
      width: 136px !important;
    }
  }

  .search-right {
    display: flex;
    align-items: center;
    margin-right: 8px;

    .search-time {
      margin-left: 8px;
      width: 74px !important;
    }
  }

  .mr16 {
    margin-right: 6px;
  }
}

.home-user {
  background-color: #fff;
  padding: 20px;
}

.home-user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.9) 100%);
  border-radius: 4px;
  border: 1px solid #fff;
  backdrop-filter: blur(25px);
  padding: 5px 20px;

  .user-info {
    .user-name {
      height: 14px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333;
      line-height: 14px;
      display: inline-block;
      padding: 6px 0;
    }
  }

  .user-update {
    display: flex;
    align-items: center;

    .user-update-text {
      height: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 12px;
      display: flex;
      align-items: center;
    }

    .time-icon-pic {
      width: 14px;
      height: 14px;
    }

    .user-update-time {
      height: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333;
      line-height: 12px;
    }

    .reset-img {
      width: 16px;
      height: 16px;
      margin: 0 0 0 20px;
      cursor: pointer;
    }
  }

  /* 旋转动画 */
  .rotate {
    animation: spin 0.8s infinite;
  }

  /* 定义旋转动画关键帧 */
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .el-dropdown-link {
    font-size: 11px;
    cursor: pointer;
    color: #86909c;
    margin-left: 12px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
}

.date-picker-wrapper {
  position: relative;

  /* 为自定义图标绝对定位提供参考 */
  display: inline-block;

  /* 使容器大小由内容决定 */
  width: 100%;

  /* 或其他需要的宽度 */
}

.time-box {
  position: relative;
}

/* 自定义箭头图标样式 */
.custom-arrow-icon {
  position: absolute;
  right: 6px;

  /* 调整右侧距离 */
  top: 50%;
  transform: translateY(-50%);

  /* 垂直居中 */
  color: #c0c4cc;

  /* 箭头颜色，与 select 保持一致 */
  font-size: 12px;
  pointer-events: none;

  /* 避免图标干扰输入框操作 */
  z-index: 2;

  /* 确保图标显示在输入框上方 */
}
</style>
<style lang="less">
.home-search-list {
  .search-cascader {
    width: 136px;

    .el-input,
    .el-input input {
      height: 24px !important;
    }
  }

  .search-select {
    width: 136px;
    height: 24px;

    .el-input,
    .el-input input {
      height: 24px !important;
    }

    .el-input__icon {
      line-height: 24px !important;
    }
  }

  .search-radio {
    display: flex;
    align-items: center;

    .el-radio-button__inner {
      padding: 5px 15px;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #2881ff;
      border-color: #2881ff;
      background-color: #e5f0fe;
    }

    .el-radio-button:first-child:last-child .el-radio-button__inner {
      border-radius: 0 2px 2px 0 !important;
    }
  }

  .search-left .el-select .el-input input {
    height: 24px !important;
  }

  .search-left .el-select__tags {
    height: 24px !important;
  }

  .search-left .el-cascader--mini {
    line-height: 24px !important;
  }

  .search-left .el-input--mini .el-input__icon {
    line-height: 24px !important;
  }

  .search-left .el-select__tags {
    flex-wrap: nowrap !important;

    .el-select__tags-text {
      max-width: 56px !important;
    }
  }

  .search-left .el-cascader__tags {
    flex-wrap: nowrap !important;

    .el-tag--info span {
      max-width: 65px !important;
    }
  }

  .search-time .el-input__inner {
    background-color: #fff;

    /* 背景颜色，通常与 el-select 一致 */
    border: 1px solid #dcdfe6;

    /* 边框颜色 */
    border-radius: 4px;

    /* 边框圆角 */
    height: 24px;

    /* 高度，调整至与你的 el-select 相同 */
    line-height: 24px;

    /* 行高，通常与高度一致以实现垂直居中 */
    color: #606266;

    /* 文字颜色 */
    padding: 0 15px;

    /* 内边距，根据实际情况调整 */
    cursor: pointer;

    /* 手型光标，与 select 一致表示可点击 */

    /* 其他你希望统一的样式 */
  }

  .search-month-time .el-input__inner {
    padding: 0 5px;

    /* 内边距，根据实际情况调整 */
  }

  /* 悬停状态样式 */
  .search-time .el-input__wrapper:hover {
    box-shadow: 0 0 0 1px #409eff inset !important;

    /* 模拟 el-select 的悬停边框颜色，颜色值请按需调整 */
  }

  /* 聚焦状态样式 */
  .search-time .el-input__wrapper.is-focus {
    box-shadow: 0 0 0 1px #409eff inset !important;

    /* 模拟 el-select 的聚焦边框颜色 */
  }

  /* 隐藏默认的日历图标 */
  .search-time .el-input__icon {
    display: none;
  }

  .el-cascader .el-input .el-icon-arrow-down,
  .el-select__caret .el-input__icon .el-icon-arrow-up,
  .el-select .el-input .el-select__caret {
    font-size: 12px;
  }
}
</style>
